module.exports = __webpack_public_path__ + "img/corumch-logo-white.8d55e8a3.svg";